export default __webpack_public_path__ + "images/35_1_image.jpg";